import { Component, OnInit } from '@angular/core';
import { OrderService, OrderFilters } from 'src/app/services/order.service';
import { Order } from 'src/app/models/order';
import { User } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { Customer } from 'src/app/models/customer';
import { ToastrManager } from 'ng6-toastr-notifications';
import { LogisticEventsService } from 'src/app/services/logistic-events.service';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class OrderComponent implements OnInit {
  orders:Order[] = [];
  ordersAll:Order[] = [];
  sellers:User[] = [];
  loading:boolean = false;
  isAdmin:boolean = false;
  actAddOrder:boolean = false;
  customers:Customer[] = [];
  selectedCustomers:Customer[] = [];
  customer:Customer;
  canDelete:boolean = false;
  expand:boolean = false;

  canEdit:boolean = false;
  canGet:boolean = false;

  filters:OrderFilters = {
    date1: new Date(),
    date2: new Date(),
    status: '',
    user: 0,
  };

  updown:number = 1;
  sorted:string = '';

  constructor(private orderServ:OrderService, private userServ:UserService, private utl:UtilitiesService, private authServ:AuthService, private toastr: ToastrManager, private logisticEv:LogisticEventsService) { }

  async ngOnInit() {
    this.loading = true;

    this.isAdmin = this.authServ.is('admin') || this.authServ.is('logistic');
    this.canEdit = this.authServ.can('update-order');
    this.canGet = this.authServ.can('get-orders');
    this.actAddOrder = this.authServ.can('store-order');
    this.canDelete = this.authServ.can('destroy-order');

    if(this.isAdmin)
      this.sellers = await this.userServ.getUsers('sales');

    this.filters = {
      status,
      date1: new Date(),
      date2: new Date(),
      user: 0,
    };
    
    this.loading = false;
  }
  
  async getOrders() {
    this.loading = true;
    this.orders = await this.orderServ.getOrders(this.filters);
    this.ordersAll = this.orders;
    this.allCustomers();
    this.loading = false;
  }

  sort(param) {
    this.orders = this.orders.sort(this.utl.dynamicSort((this.updown == 1 ? '' : '-') + param));
    this.updown = this.updown*-1;
    this.sorted = param;
  }

  addFilter() {
    if (this.customer) {
      this.selectedCustomers.push(this.customer);
      this.orders = this.utl.filterBy(this.ordersAll, 'customer.name', this.selectedCustomers.map(c => c.name));
    } else {
      this.selectedCustomers = [];
      this.orders = this.ordersAll;
    }
  }

  allCustomers() {
    this.customers = [];
    this.ordersAll.forEach(or => {
      if (!this.customers.find(c => c.id == or.customer_id)) {
        this.customers.push(or.customer);
      }
    });
  }

  async deleteOrder(id){
    try{
      let order = this.orders.find(ord => ord.id == id);
      await this.orderServ.deleteOrder(order);
      order.status = 'Cancelado';

      this.toastr.successToastr("Orden eliminada correctamente!");
      this.logisticEv.sendOrderDeleted(order);
    }catch (resp)
    {
      if (resp.error.message) {
        this.toastr.errorToastr(resp.error.message);
      } else {
        this.toastr.errorToastr('Error al eliminar orden');
      }
    }
  }

}
